<template>
  <div>
    <div :class="['top-tasks', isOpenTaskDrop ? 'active' : '']" @click="tasks.length != 0 ? openCloseDrop() : ''">
      <div class="top-tasks-no tasks-animation">{{ tasks.length }}</div>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23">
        <g>
          <g>
            <path fill="#2b2b41"
              d="M20 3.298v18.856c0 .466-.39.846-.866.846H.866A.858.858 0 0 1 0 22.154V3.298c0-.465.39-.846.866-.846h2.189c.476 0 .866.38.866.846 0 .465-.39.845-.866.845H1.732V21.31h16.54V4.143h-4.647a.858.858 0 0 1-.866-.845V1.69H7.25V4.45h4.484c.477 0 .866.38.866.845 0 .465-.39.846-.866.846h-5.35a.859.859 0 0 1-.866-.846V.846c0-.466.39-.846.866-.846h7.236c.477 0 .866.38.866.846v1.606h4.648c.476 0 .866.38.866.846zm-6.014 8.094l-4.652 4.505a.87.87 0 0 1-.611.244.878.878 0 0 1-.616-.249L6.019 13.84a.832.832 0 0 1 .004-1.197.882.882 0 0 1 1.227.004l1.477 1.452 4.037-3.909a.881.881 0 0 1 1.227.005.832.832 0 0 1-.005 1.198z" />
          </g>
        </g>
      </svg>
    </div>
    <div class="top-tasks-menu tasknot">
      <div class="task-element-wrapper" v-for="(single_task, key) in tasks" :key="key" @click="openPopup(single_task)">
        <div :class="'vrsta-eventa event-' + single_task.event_type.class_colour">
          {{ single_task.event_type.name }}
          <div class="task-date">
          </div>
        </div>
        <div class="task-date-name-wrapper">
          <div :title="single_task.title" class="task-name ellipsis-overflow">
            {{ single_task.title }}
          </div>
          <div class="task-date">
              {{formatDate(single_task.end_date_time)}}
          </div>
        </div>
      </div>
      <!-- <div class="task-divider"></div> -->
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import CalendarModal from "@/components/calendarComponents/CalendarModal.vue";
import NotificationComponent from "@/components/generalComponents/NotificationComponent.vue";
import TasksDropdown from "@/components/generalComponents/TasksDropdown.vue";
import moment from "moment"

export default {
  components: { CalendarModal, NotificationComponent, TasksDropdown },
  props: {
    sioVar: {
      type: Object,
      required: false,
      default: null,
    },
  },
  methods: {
    openCloseDrop() {
      this.$parent.$refs.sysDrop.isOpenTaskDrop = false;
      this.isOpenTaskDrop = !this.isOpenTaskDrop
    },
    openPopup(event) {
      setTimeout(() => {
        this.$store.state.event_details.popup_open = true;
        this.$store.state.event_details.chosen_event = event;
      }, 100);

    },
    formatTime(dt_data) {
      return moment(dt_data).format("LT")
    },
    formatDate(dt_data) {
      if (dt_data == null) {
        return this.$t('components.calendar.event_card.undefined')
      }
      else if (moment(dt_data).format("L") == moment().format("L")) {
        return this.$t('components.calendar.event_card.danas')
      } else
        return moment(dt_data).format("DD.MMMM ")
    },
  },
  watch: {
    sioVar: function () {
      if (this.sioVar != null) {
        this.sioVar.socket.on("message tasks", (data) => {
          let old_length = this.tasks.length;
          this.tasks = []
          this.tasks = JSON.parse(data);
          if (this.hasFirstLoaded) {
            if (old_length > this.tasks.length) {
              gsap.to(".tasks-animation", 1, { width: "5rem", height: "5rem", backgroundColor: "#0acab1" })
              gsap.to(".tasks-animation", 1, { delay: 3, width: "2rem", height: "2rem" })
              gsap.to(".tasks-animation", 0.4, { delay: 4, backgroundColor: "#fd4087" })
            } else if (old_length < this.tasks.length) {
              gsap.to(".tasks-animation", 1, { width: "5rem", height: "5rem" })
              gsap.to(".tasks-animation", 1, { delay: 3, width: "2rem", height: "2rem" })

            }
          } else {
            this.hasFirstLoaded = true;
          }


        });
      }
    },

    isOpenTaskDrop: function () {
      if (!this.isOpenTaskDrop) {
        if (!this.$parent.isOpenDropDown && !this.$parent.$refs.sysDrop.isOpenTaskDrop) {
          gsap.to(".router-wrapper", 0.5, {
            filter: "none",
            pointerEvents: "auto",
            opacity: 1,
          });
        }
        let tl = gsap.timeline();
        tl.fromTo(".tasknot", 0.3, { y: 0 }, { y: -20, opacity: 0 });
        tl.to(".tasknot", 0, { display: "none" });
      } else {
        gsap.to(".router-wrapper", 0.5, {
          filter: "blur(5px)",
          pointerEvents: "none",
          opacity: 0.5,
        });
        let tl = gsap.timeline();
        tl.to(".tasknot", 0, { display: "block" });
        tl.to(".sysnot", 0, { display: "none" });
        tl.fromTo(".tasknot", 0.3, { y: -20 }, { y: 0, opacity: 1 });
        tl.fromTo(".sysnot", 0.3, { y: 0 }, { y: -20, opacity: 0 });

      }
    },
  },
  data() {
    return {
      isOpenTaskDrop: false,
      tasks: [],
      hasFirstLoaded: false
    };
  },
  async created() { },
  mounted() { },
};
</script>

